const DATA_SOURCES_PANEL = 'DATA_SOURCES_PANEL';
const VARIABLE_CONTEXT = 'VARIABLE_CONTEXT';
export default {
  DATA_SOURCES_PANEL,
  VARIABLE_CONTEXT
};